import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

/**
 * Lista "Combinam com você" da sacola: adiciona o perfume sem sair da página
 * e avisa a gaveta e a página da sacola para se redesenharem, do mesmo jeito
 * que o formulário de produto do tema faz.
 */
class AninaCombinam extends HTMLElement {
  connectedCallback() {
    this.addEventListener('submit', this.#onSubmit);
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.#onSubmit);
  }

  /** @param {SubmitEvent} event */
  #onSubmit = async (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!form || !form.hasAttribute('data-anina-add')) return;
    event.preventDefault();

    const button = form.querySelector('button');
    if (!button || button.getAttribute('aria-busy') === 'true' || button.classList.contains('is-added')) return;

    const id = form.querySelector('[name="id"]')?.value;
    if (!id) return;

    const routes = window.Theme?.routes ?? {};
    const addUrl = `${routes.cart_add_url || '/cart/add'}.js`;
    const cartUrl = `${routes.cart_url || '/cart'}.js`;
    const sections = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);

    button.setAttribute('aria-busy', 'true');

    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: id, quantity: 1 }],
        promise: deferred.promise,
      })
    );

    try {
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(id), quantity: 1 }],
          sections: sections.join(','),
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      const cart = await fetch(cartUrl, { headers: { Accept: 'application/json' } }).then((r) => r.json());

      if (!response.ok || data.status) {
        this.dispatchEvent(
          new CartErrorEvent({ error: data.description || data.message || 'Add to cart failed', code: 'INVALID' })
        );
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { didError: true, items: cart.items, source: 'anina-combinam', itemCount: 1 },
        });
        this.#status(data.description || 'Não foi possível adicionar este perfume.');
        button.removeAttribute('aria-busy');
        return;
      }

      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'anina-combinam',
          itemCount: 1,
          sections: data.sections,
          didError: false,
        },
      });

      button.removeAttribute('aria-busy');
      button.classList.add('is-added');
      const texto = button.querySelector('.anina-combinam__add-texto');
      const original = texto?.textContent;
      if (texto) texto.textContent = 'Na sacola';
      this.#status('Perfume adicionado à sacola.');
      if (this.reiniciar) {
        setTimeout(() => {
          button.classList.remove('is-added');
          if (texto && original) texto.textContent = original;
        }, 2500);
      }
    } catch (error) {
      console.error(error);
      deferred.reject(error);
      button.removeAttribute('aria-busy');
      this.#status('Não foi possível adicionar este perfume.');
    }
  };

  /** @param {string} message */
  #status(message) {
    const el = this.querySelector('[data-anina-status]');
    if (el) el.textContent = message;
    else this.querySelector('button')?.setAttribute('title', message);
  }
}

if (!customElements.get('anina-combinam')) {
  customElements.define('anina-combinam', AninaCombinam);
}

/** Compra rápida dos cards da home: mesmo comportamento, e o botão volta ao normal depois. */
class AninaAdicionar extends AninaCombinam {
  reiniciar = true;
}

if (!customElements.get('anina-adicionar')) {
  customElements.define('anina-adicionar', AninaAdicionar);
}
